import React from 'react';
import { Section } from './ui/Section';
import { TestimonialCard } from './TestimonialCard';
export function TestimonialGrid() {
  const testimonials = [{
    name: 'María García',
    age: 44,
    city: 'Madrid',
    content: 'Al principio era escéptica, pero mi hermana insistió. En 3 semanas, mis pantalones de hace 5 años me vuelven a cerrar. Increíble.',
    imageSrc: 'https://randomuser.me/api/portraits/women/44.jpg',
    timeframe: '21 días'
  }, {
    name: 'Carmen López',
    age: 38,
    city: 'Valencia',
    content: 'La hinchazón después de comer era insoportable. StingFit me ha devuelto la comodidad. Me siento mucho más ligera.',
    imageSrc: 'https://randomuser.me/api/portraits/women/38.jpg',
    timeframe: '14 días'
  }, {
    name: 'Rosa Martínez',
    age: 47,
    city: 'Sevilla',
    content: 'Fácil de usar y efectivo. No esperaba resultados tan rápidos, pero la diferencia en mi abdomen es notable. Muy recomendado.',
    imageSrc: 'https://randomuser.me/api/portraits/women/47.jpg',
    timeframe: '30 días'
  }, {
    name: 'Isabel Fernández',
    age: 42,
    city: 'Barcelona',
    content: 'Lo mejor es que es natural. No quiero tomar más pastillas. Esto funciona mientras duermo y me despierto genial.',
    imageSrc: 'https://randomuser.me/api/portraits/women/42.jpg',
    timeframe: '45 días'
  }, {
    name: 'Pilar Sánchez',
    age: 50,
    city: 'Bilbao',
    content: 'Mi amiga me lo recomendó. Pensé que era una tontería, pero ahora soy yo quien lo recomienda. La calidad de vida ha mejorado.',
    imageSrc: 'https://randomuser.me/api/portraits/women/50.jpg',
    timeframe: '2 meses'
  }, {
    name: 'Ana Rodríguez',
    age: 41,
    city: 'Málaga',
    content: 'Excelente servicio y producto. Llegó rápido y los resultados se notan desde la primera semana en la digestión.',
    imageSrc: 'https://randomuser.me/api/portraits/women/41.jpg',
    timeframe: '7 días'
  }];
  return <Section background="cream" id="testimonials" data-id="element-352">
      <div className="text-center mb-12" data-id="element-353">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-354">
          Mujeres reales. Resultados reales.
        </h2>
        <p className="text-gray-600" data-id="element-355">
          Únete a más de 10.000 mujeres en España que ya han recuperado su
          confianza.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-356">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-357" />)}
      </div>
    </Section>;
}